var map = {
	"./jg0/pgd_a_00000.png": "95f8",
	"./jg0/tapcy.png": "7e63",
	"./jg1/pgd_a_00001.png": "dd28",
	"./jg1/pgd_a_00010.png": "b2a7",
	"./jg1/pgd_a_00100.png": "50c7",
	"./jg1/pgd_a_01000.png": "0779",
	"./jg1/pgd_a_10000.png": "4fd4",
	"./jg2/pgd_a_00011.png": "dbf0",
	"./jg2/pgd_a_00101.png": "55dd",
	"./jg2/pgd_a_00110.png": "5236",
	"./jg2/pgd_a_01001.png": "64f5",
	"./jg2/pgd_a_01010.png": "4a01f",
	"./jg2/pgd_a_01100.png": "7028",
	"./jg2/pgd_a_10001.png": "51ae",
	"./jg2/pgd_a_10010.png": "96fa",
	"./jg2/pgd_a_10100.png": "ec36",
	"./jg2/pgd_a_11000.png": "5ccc",
	"./jg3/pgd_a_00111.png": "9e7e",
	"./jg3/pgd_a_01011.png": "d7e2",
	"./jg3/pgd_a_01101.png": "c159",
	"./jg3/pgd_a_01110.png": "23b9",
	"./jg3/pgd_a_10011.png": "bb35",
	"./jg3/pgd_a_10101.png": "ffca",
	"./jg3/pgd_a_10110.png": "1fd1",
	"./jg3/pgd_a_11001.png": "2185",
	"./jg3/pgd_a_11010.png": "b34e",
	"./jg3/pgd_a_11100.png": "d94c",
	"./jg4/pgd_a_01111.png": "a90c",
	"./jg4/pgd_a_10111.png": "6343",
	"./jg4/pgd_a_11011.png": "e185",
	"./jg4/pgd_a_11101.png": "7aa3",
	"./jg4/pgd_a_11110.png": "2f2a",
	"./jg5/pgd_a_11111.png": "6899",
	"./jg6/pgd_a_111111.png": "71a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "910d";